/* Extras do carrinho novo (nativo, sem app):
   - Brinde automático: entra a R$0 quando o subtotal atinge a meta, sai se cair abaixo.
   - Upsell em lista: botão "Adicionar" com refresh do drawer.
   Config vem dos data-attributes do <cart-drawer> (Configurações do tema → Carrinho). */
(function () {
  var busy = false;
  // Trava PRÓPRIA do checkout. Antes o paCheckout reusava `busy`, que é do reconcileGift —
  // e o `.finally` do reconcile zera `busy` sem saber que o checkout também o marcara.
  // Resultado: reconcile terminava, liberava a trava alheia, rodava de novo, via que o
  // carrinho qualifica e sem brinde, e RECOLOCAVA o brinde já removido — que então seguia
  // para a Yampi e era cobrado. Janela estreita (clicar em Finalizar no instante em que o
  // brinde entra), mas real. Esta aqui só o próprio checkout levanta e abaixa.
  var indoPraCheckout = false;
  var timer = null;

  // Brindes ativos. São dois slots independentes: o fixo e o de promoção curta.
  // A janela de datas de cada um é resolvida no Liquid — aqui só chega enabled=true
  // quando hoje está dentro dela, então este arquivo não precisa saber de calendário.
  function brindes() {
    var el = document.querySelector('cart-drawer');
    if (!el) return [];
    var lista = [];
    if (el.dataset.paGiftEnabled === 'true') {
      lista.push({
        variant: parseInt(el.dataset.paGiftVariant, 10) || 0,
        threshold: (parseFloat(el.dataset.paGiftThreshold) || 0) * 100
      });
    }
    if (el.dataset.paGift2Enabled === 'true') {
      lista.push({
        variant: parseInt(el.dataset.paGift2Variant, 10) || 0,
        threshold: (parseFloat(el.dataset.paGift2Threshold) || 0) * 100
      });
    }
    return lista.filter(function (b) { return b.variant && b.threshold; });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function refreshDrawer() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var tmp = document.createElement('div');
        if (data['cart-drawer']) {
          tmp.innerHTML = data['cart-drawer'];
          var freshInner = tmp.querySelector('.drawer__inner');
          var curInner = document.querySelector('cart-drawer .drawer__inner');
          if (freshInner && curInner) curInner.innerHTML = freshInner.innerHTML;
          var freshRoot = tmp.querySelector('cart-drawer');
          var curRoot = document.querySelector('cart-drawer');
          if (freshRoot && curRoot) curRoot.classList.toggle('is-empty', freshRoot.classList.contains('is-empty'));
        }
        if (data['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) bubble.innerHTML = new DOMParser()
            .parseFromString(data['cart-icon-bubble'], 'text/html')
            .querySelector('.shopify-section').innerHTML;
        }
        if (typeof paCouponSync === 'function') paCouponSync();
      })
      .catch(function () {});
  }

  // se um código KIT está aplicado, mantém o degrau certo conforme as unidades do carrinho
  function kitCodeApplied(cart) {
    var applied = null;
    cart.items.forEach(function (i) {
      (i.discounts || []).forEach(function (d) {
        var m = /^KIT(10|15|20)$/i.exec((d.title || '').trim());
        if (m) applied = 'KIT' + m[1];
      });
      (i.line_level_discount_allocations || []).forEach(function (a) {
        var t = a.discount_application && a.discount_application.title;
        var m = /^KIT(10|15|20)$/i.exec((t || '').trim());
        if (m) applied = 'KIT' + m[1];
      });
    });
    return applied;
  }

  // Confete quando a barra de progresso completa 🎉
  function paConfetti() {
    var host = document.querySelector('cart-drawer .drawer__inner');
    if (!host) return;
    var c = document.createElement('canvas');
    c.className = 'pa-confetti';
    c.width = host.clientWidth; c.height = host.clientHeight;
    host.appendChild(c);
    var ctx = c.getContext('2d');
    var colors = ['#BF4737', '#E8A33D', '#E8C9BC', '#94452F', '#6E9E63'];
    var parts = [];
    for (var i = 0; i < 90; i++) {
      parts.push({ x: c.width / 2, y: c.height * 0.22, vx: (Math.random() - 0.5) * 10, vy: Math.random() * -8 - 3, g: 0.28, s: Math.random() * 6 + 4, r: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.3, col: colors[i % colors.length], life: 90 + Math.random() * 50 });
    }
    var t = 0;
    (function tick() {
      t++; ctx.clearRect(0, 0, c.width, c.height);
      var alive = false;
      parts.forEach(function (p) {
        if (p.life <= 0) return;
        alive = true; p.life--; p.vy += p.g; p.x += p.vx; p.y += p.vy; p.r += p.vr;
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r);
        ctx.globalAlpha = Math.min(p.life / 50, 1);
        ctx.fillStyle = p.col; ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.6);
        ctx.restore();
      });
      if (alive && t < 220) requestAnimationFrame(tick); else c.remove();
    })();
  }
  // Safari iOS às vezes não pinta o width inline após innerHTML swap — reforça via JS
  function paFixProgress() {
    var pr = document.querySelector('cart-drawer .pa-progress');
    if (!pr) return;
    var f = pr.querySelector('.pa-progress__fill');
    var pct = parseFloat(pr.getAttribute('data-pct'));
    if (f && !isNaN(pct)) {
      pct = Math.min(pct, 100);
      f.style.transform = 'scaleX(' + (pct / 100) + ')';
    }
  }
  var paGoalInit = false;
  function paCheckGoal() {
    paFixProgress();
    var el = document.querySelector('cart-drawer .pa-progress');
    if (!el) return;
    var done = el.getAttribute('data-done') === 'true';
    var was = false;
    try { was = sessionStorage.getItem('pa-goal-done') === '1'; } catch (e) {}
    if (done && !was) {
      try { sessionStorage.setItem('pa-goal-done', '1'); } catch (e) {}
      if (paGoalInit) paConfetti();
    }
    if (!done && was) { try { sessionStorage.removeItem('pa-goal-done'); } catch (e) {} }
    paGoalInit = true;
  }

  /* placeholder "Adicionando seu brinde..." — feedback imediato enquanto o
     add do brinde + refresh do drawer rodam (~1-2s). Some sozinho quando o
     refreshDrawer troca o .drawer__inner; o finally é só limpeza de erro. */
  function giftPlaceholderShow() {
    if (document.getElementById('pa-gift-loading')) return;
    var host = document.querySelector('cart-drawer #CartDrawer-CartItems') ||
               document.querySelector('cart-drawer .drawer__inner');
    if (!host) return;
    var el = document.createElement('div');
    el.id = 'pa-gift-loading';
    el.className = 'pa-gift-loading';
    el.textContent = 'Adicionando seu brinde...';
    host.appendChild(el);
  }
  function giftPlaceholderHide() {
    var el = document.getElementById('pa-gift-loading');
    if (el) el.remove();
  }

  function reconcileGift() {
    if (indoPraCheckout) { return; }   // indo pro checkout: não mexe mais no carrinho
    if (busy) { schedule(); return; }
    busy = true;
    var c = brindes();
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var chain = Promise.resolve();

        // 1) brindes automáticos — cada um com a sua meta
        if (c.length) {
          var idsBrinde = c.map(function (b) { return b.variant; });
          // a meta olha só o que o cliente PAGA: nenhum brinde entra na conta,
          // senão um brinde empurraria o carrinho para a meta do outro
          var sub = 0;
          cart.items.forEach(function (i) {
            if (idsBrinde.indexOf(i.variant_id) === -1) sub += i.final_line_price;
          });
          var avisou = false;
          c.forEach(function (b) {
            var linha = cart.items.filter(function (i) { return i.variant_id === b.variant; })[0];
            var qualifica = sub >= b.threshold;
            if (qualifica && !linha) {
              if (!avisou) { giftPlaceholderShow(); avisou = true; }
              chain = chain.then(function () {
                return postJSON('/cart/add.js', { items: [{ id: b.variant, quantity: 1 }] });
              });
            } else if (!qualifica && linha) {
              chain = chain.then(function () {
                return postJSON('/cart/change.js', { id: linha.key, quantity: 0 });
              });
            } else if (linha && linha.quantity !== 1) {
              chain = chain.then(function () {
                return postJSON('/cart/change.js', { id: linha.key, quantity: 1 });
              });
            }
          });
        }

        // 2) desconto progressivo: aplica/ajusta o cupom KIT (10/15/20) AUTOMATICAMENTE
        // conforme as unidades pagas — espelha a regra automática da Yampi no checkout,
        // pra drawer e checkout baterem 1:1. NUNCA sobrescreve cupom de outro tipo que
        // o cliente aplicou (lido do data-pa-code renderizado pelo cart-drawer.liquid).
        // liga/desliga pelo editor: Configurações do tema → Incentivo do desconto progressivo
        var autoEl = document.querySelector('cart-drawer .drawer__inner[data-pa-kit-auto]');
        var autoOn = autoEl && autoEl.getAttribute('data-pa-kit-auto') === 'true';
        if (autoOn) {
          var units = 0;
          cart.items.forEach(function (i) { if (!c || i.variant_id !== c.variant) units += i.quantity; });
          var want = units >= 4 ? 'KIT20' : units === 3 ? 'KIT15' : units === 2 ? 'KIT10' : null;
          var codeEl = document.querySelector('cart-drawer .drawer__inner[data-pa-code]');
          var code = codeEl ? (codeEl.getAttribute('data-pa-code') || '').trim().toUpperCase() : '';
          var isForeign = code !== '' && !/^KIT(10|15|20)$/.test(code);
          if (want && !isForeign && code !== want) {
            chain = chain.then(function () {
              try { localStorage.setItem('pa-kit-code', want); } catch (e) {}
              return fetch('/discount/' + want);
            });
          }
        } else {
          // modo manual: remove código KIT residual do carrinho (ex.: cookie de quando o
          // automático esteve ligado). NUNCA remove cupom de outro tipo.
          var codeEl2 = document.querySelector('cart-drawer .drawer__inner[data-pa-code]');
          var code2 = codeEl2 ? (codeEl2.getAttribute('data-pa-code') || '').trim().toUpperCase() : '';
          // cupom que o cliente digitou no campo do drawer NÃO é residual — preserva
          var manualCode = '';
          try { manualCode = (sessionStorage.getItem('pa-coupon-manual') || '').trim().toUpperCase(); } catch (e) {}
          if (/^KIT(10|15|20)$/.test(code2) && code2 !== manualCode) {
            chain = chain.then(function () {
              return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) });
            });
          }
          try { localStorage.removeItem('pa-kit-code'); } catch (e) {}
        }

        return chain.then(refreshDrawer).then(paCheckGoal);
      })
      .catch(function () {})
      .finally(function () { busy = false; giftPlaceholderHide(); });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcileGift, 400);
  }

  // Reage a qualquer mutação do carrinho (tema, upsell, kit, PDP…)
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    if (url && typeof url === 'object' && url.url) url = url.url;
    var p = origFetch.apply(this, arguments);
    try {
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function (r) { schedule(); return r; }, function () { schedule(); });
      }
    } catch (e) {}
    return p;
  };

  // Ignora "cliques" que na verdade foram deslizes (toque que se moveu >10px)
  var paTouchX = 0, paTouchY = 0, paTouchMoved = false;
  document.addEventListener('touchstart', function (e) {
    var t = e.touches[0]; paTouchX = t.clientX; paTouchY = t.clientY; paTouchMoved = false;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    var t = e.touches[0];
    if (Math.abs(t.clientX - paTouchX) > 6 || Math.abs(t.clientY - paTouchY) > 6) paTouchMoved = true;
  }, { passive: true });

  // Bloqueia cliques logo após rolagem dentro do drawer (toque-arrasto no iOS)
  var paLastScroll = 0;
  document.addEventListener('scroll', function (e) {
    try { if (e.target && e.target.closest && e.target.closest('cart-drawer')) paLastScroll = Date.now(); } catch (err) {}
  }, true);

  // Upsell em lista: adicionar produto
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pa-upsell__add');
    if (!btn) return;
    if (paTouchMoved) return;
    if (Date.now() - paLastScroll < 300) return;
    var row = btn.closest('[data-pa-item]') || btn.closest('.pa-upsell__row');
    var sel = row && row.querySelector('.pa-upsell__select');
    var id = parseInt(sel && sel.value, 10);
    if (!id) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    postJSON('/cart/add.js', { items: [{ id: id, quantity: 1 }] })
      .then(refreshDrawer)
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  });

  /* ---- Cupom digitado no drawer (só com checkout Shopify) ----
     Aplica via /cart/update.js {discount}; valida no /cart.js (applicable) e,
     se a API não listar o código, confere se ele virou desconto de verdade.
     Código digitado fica marcado em sessionStorage pra que o reconcile do modo
     manual não o remova junto com os KIT residuais. */
  /* GOTCHA: o drawer inteiro é re-renderizado a cada mutação do carrinho (reconcile),
     então nada do que o cliente digitou/viu sobrevive no DOM. Todo o estado do campo
     de cupom mora aqui e é reaplicado depois de cada refresh (paCouponRestore). */
  var paCouponState = { open: false, value: '', error: '', note: '' };

  function paCouponBox() { return document.querySelector('cart-drawer [data-pa-coupon]'); }

  function paCouponMsg(txt, isError) {
    paCouponState.error = isError ? (txt || '') : '';
    var box = paCouponBox();
    var p = box && box.querySelector('.pa-coupon-msg');
    if (!p) return;
    p.textContent = txt || '';
    p.classList.toggle('is-error', !!isError);
    p.classList.toggle('is-visible', !!txt);
  }

  function paCouponErrText() {
    var box = paCouponBox();
    var p = box && box.querySelector('.pa-coupon-msg');
    return (p && p.getAttribute('data-pa-coupon-error')) ||
           'Cupom inválido ou não aplicável a este carrinho.';
  }

  // devolve o campo ao estado em que o cliente o deixou (aberto, digitado, com erro)
  function paCouponRestore() {
    var box = paCouponBox();
    if (!box) return;
    var det = box.querySelector('.pa-coupon-details');
    if (det && (paCouponState.open || paCouponState.value || paCouponState.error)) {
      det.open = true;
      var input = det.querySelector('.pa-coupon-input');
      if (input && paCouponState.value && !input.value) input.value = paCouponState.value;
    }
    var txt = paCouponState.error || paCouponState.note;
    if (txt) {
      var p = box.querySelector('.pa-coupon-msg');
      if (p) {
        p.textContent = txt;
        p.classList.toggle('is-error', !!paCouponState.error);
        p.classList.add('is-visible');
      }
    }
  }

  function paCurrentCode() {
    var el = document.querySelector('cart-drawer .drawer__inner[data-pa-code]');
    return el ? (el.getAttribute('data-pa-code') || '').trim().toUpperCase() : '';
  }

  function paManualCode(code) {
    try {
      if (code) sessionStorage.setItem('pa-coupon-manual', code.toUpperCase());
      else sessionStorage.removeItem('pa-coupon-manual');
    } catch (e) {}
  }

  // 'ok' | 'bad' | null (a API não disse nada sobre esse código)
  function paCodeState(cart, code) {
    var list = cart.discount_codes || [];
    for (var i = 0; i < list.length; i++) {
      if ((list[i].code || '').trim().toUpperCase() === code) {
        return list[i].applicable === false ? 'bad' : 'ok';
      }
    }
    var found = false;
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if ((d.title || '').trim().toUpperCase() === code) found = true;
    });
    (cart.items || []).forEach(function (it) {
      (it.discounts || []).forEach(function (d) {
        if ((d.title || '').trim().toUpperCase() === code) found = true;
      });
    });
    return found ? 'ok' : null;
  }

  /* cupom de FRETE GRÁTIS não vira desconto no carrinho (só no checkout), então o
     Liquid não tem como renderizar o chip. Aqui o chip é montado no cliente a partir
     do código digitado, confirmando no /cart.js que ele segue aplicável. */
  function paRenderChip(box, code) {
    var det = box.querySelector('.pa-coupon-details');
    if (!det) return;
    var wrap = document.createElement('div');
    wrap.className = 'pa-coupon-applied';
    var span = document.createElement('span');
    span.className = 'pa-coupon-applied__code';
    span.textContent = '🏷 ' + code;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pa-coupon-remove';
    btn.textContent = 'Remover';
    wrap.appendChild(span);
    wrap.appendChild(btn);
    det.replaceWith(wrap);
    paHideDupChip();
  }

  /* o código aplicado já aparece como chip no card de resumo; com a caixa de cupom
     mostrando o mesmo código logo abaixo, a repetição some (chips de desconto
     AUTOMÁTICO continuam visíveis). */
  function paHideDupChip() {
    var box = paCouponBox();
    var el = box && box.querySelector('.pa-coupon-applied__code');
    if (!el) return;
    var alvo = (el.textContent || '').replace('🏷', '').trim().toUpperCase();
    if (!alvo) return;
    document.querySelectorAll('cart-drawer .pa-chip').forEach(function (chip) {
      var t = (chip.textContent || '').replace('🏷', '').trim().toUpperCase();
      if (t === alvo) chip.style.display = 'none';
    });
  }

  function paCouponSync() {
    paCouponRestore();
    var box = paCouponBox();
    if (!box) return;
    if (box.querySelector('.pa-coupon-applied')) { paHideDupChip(); return; } // Liquid já mostrou o chip
    var code = '';
    try { code = (sessionStorage.getItem('pa-coupon-manual') || '').trim(); } catch (e) {}
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // o Liquid não expõe o código aplicado de forma confiável (cart_level tem title
        // nulo), então a verdade vem do /cart.js — e assim o chip também aparece quando o
        // código entrou por link /discount/X ou em outra aba.
        var applied = (cart.discount_codes || []).filter(function (d) { return d.applicable !== false; });
        var show = '';
        for (var i = 0; i < applied.length; i++) {
          var c = (applied[i].code || '').trim();
          if (!c) continue;
          if (code && c.toUpperCase() === code.toUpperCase()) { show = c; break; }
          if (!show) show = c;
        }
        // NÃO marca como "digitado pelo cliente" um código que veio de outro lugar —
        // isso furaria a limpeza de KIT residual do modo manual.
        if (!show) { if (code) paManualCode(''); return; }
        var fresh = paCouponBox();
        if (fresh && !fresh.querySelector('.pa-coupon-applied')) paRenderChip(fresh, show.toUpperCase());
      })
      .catch(function () {});
  }

  function paCouponBtn(txt, disabled) {
    var box = paCouponBox();
    var btn = box && box.querySelector('.pa-coupon-apply');
    if (!btn) return;
    btn.disabled = !!disabled;
    if (txt) btn.textContent = txt;
  }

  function paCouponApply(code) {
    var errTxt = paCouponErrText();
    var label = (function () {
      var box = paCouponBox();
      var b = box && box.querySelector('.pa-coupon-apply');
      return b ? b.textContent : 'Aplicar';
    })();
    var prev = paCurrentCode();
    paCouponState.value = code;
    paCouponState.open = true;
    paCouponState.note = '';
    paCouponMsg('');
    paCouponBtn('…', true);
    paManualCode(code);

    return postJSON('/cart/update.js', { discount: code })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var state = paCodeState(cart, code);
        if (state === 'bad' || state === null) {
          // desfaz: volta pro código anterior (ou limpa) pra não levar lixo pro checkout
          paManualCode(prev);
          return postJSON('/cart/update.js', { discount: prev })
            .catch(function () {})
            .then(function () {
              paCouponBtn(label, false);
              paCouponMsg(errTxt, true);
            });
        }
        // cupom de frete grátis (ou que só vale no checkout) não muda o total aqui —
        // avisa em vez de deixar o cliente achando que não pegou
        var note = cart.total_discount > 0 ? '' : 'Cupom aplicado — o desconto aparece no checkout.';
        paCouponState = { open: false, value: '', error: '', note: note };
        return refreshDrawer();
      })
      .catch(function () {
        paCouponBtn(label, false);
        paCouponMsg(errTxt, true);
      });
  }

  function paCouponRemove() {
    paCouponState = { open: false, value: '', error: '', note: '' };
    paManualCode('');
    var box = paCouponBox();
    var btn = box && box.querySelector('.pa-coupon-remove');
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    return postJSON('/cart/update.js', { discount: '' })
      .then(refreshDrawer)
      .catch(function () {
        var b = paCouponBox() && paCouponBox().querySelector('.pa-coupon-remove');
        if (b) { b.disabled = false; b.textContent = 'Remover'; }
      });
  }

  document.addEventListener('click', function (e) {
    var sum = e.target.closest('.pa-coupon-details > summary');
    if (sum) {
      var det = sum.parentElement;
      setTimeout(function () { paCouponState.open = !!det.open; }, 0);
      return;
    }
    var apply = e.target.closest('.pa-coupon-apply');
    if (apply) {
      if (paTouchMoved || Date.now() - paLastScroll < 300) return;
      var box = apply.closest('[data-pa-coupon]');
      var input = box && box.querySelector('.pa-coupon-input');
      var code = input ? input.value.trim().toUpperCase() : '';
      if (!code) { if (input) input.focus(); return; }
      paCouponApply(code);
      return;
    }
    var rem = e.target.closest('.pa-coupon-remove');
    if (rem) {
      if (paTouchMoved || Date.now() - paLastScroll < 300) return;
      paCouponRemove();
    }
  });

  // guarda o que o cliente está digitando (o drawer pode re-renderizar no meio)
  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('.pa-coupon-input');
    if (!input) return;
    paCouponState.value = input.value;
    paCouponState.open = true;
    if (paCouponState.error) paCouponMsg('');
  });

  // Enter no campo aplica (sem submit de formulário)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('.pa-coupon-input');
    if (!input) return;
    e.preventDefault();
    var code = input.value.trim().toUpperCase();
    if (code) paCouponApply(code);
  });

  // Checkout: remove o brinde (o Yampi aplica o brinde dele na etapa seguinte).
  // Modo TESTE Shopify (setting pa_checkout_shopify): vai direto pro checkout nativo
  // e MANTÉM o brinde R$0 no pedido (a regra de brinde da Yampi não roda lá).
  window.paCheckout = function () {
    var el = document.querySelector('cart-drawer');
    var vs = brindes().map(function (b) { return b.variant; });
    var strip = el ? el.dataset.paGiftStrip === 'true' : false;
    // A rota do toggle pa_checkout_shopify (teste de checkout nativo, ago/26) foi
    // removida em 24/09/26: o teste acabou e ela era um caminho vivo para o checkout
    // errado. A setting pode continuar existindo no tema; ela simplesmente não age mais.
    // O snippet da Yampi é carregado no FIM do layout (linha ~430 de 434), então
    // window.yampiClick só existe depois que a página quase inteira chegou. Numa PDP
    // de ~1,2 MB em rede móvel, dá para clicar em Finalizar antes disso. Antes, esse
    // caso ia direto para /checkout (checkout nativo da Shopify, que não deveria ser
    // usado). Agora esperamos a Yampi aparecer (a cada 250ms, por ~10s), com uma
    // bolinha girando dentro do próprio botão. Se ela não vier, o botão volta ao
    // normal com um aviso para tentar de novo — NÃO existe mais nenhuma rota deste
    // arquivo para /checkout. Isso é proposital: o checkout nativo não deve ser usado.
    var paBotaoCarregando = function () {
      var btns = document.querySelectorAll('.cart__checkout-button, .pa-checkout');
      if (!btns.length) return;
      if (!document.getElementById('pa-btn-spin-style')) {
        var st = document.createElement('style');
        st.id = 'pa-btn-spin-style';
        st.textContent =
          '@keyframes pa-spin{to{transform:rotate(360deg)}}' +
          '.pa-btn-spin{display:inline-block;width:1.8rem;height:1.8rem;border:2px solid currentColor;' +
          'border-bottom-color:transparent;border-radius:50%;animation:pa-spin .8s linear infinite;vertical-align:middle}';
        document.head.appendChild(st);
      }
      Array.prototype.forEach.call(btns, function (b) {
        if (b.dataset.paEsperando) return;
        b.dataset.paEsperando = '1';
        b.dataset.paTextoOriginal = b.innerHTML;    // para devolver o botão se a Yampi não vier
        b.innerHTML = '<span class="pa-btn-spin" role="status" aria-label="Carregando"></span>';
        b.disabled = true;                 // evita clique duplo enquanto espera
      });
    };

    var paBotaoFalhou = function () {
      var btns = document.querySelectorAll('.cart__checkout-button, .pa-checkout');
      Array.prototype.forEach.call(btns, function (b) {
        if (!b.dataset.paEsperando) return;
        delete b.dataset.paEsperando;
        b.disabled = false;
        b.innerHTML = b.dataset.paTextoOriginal || 'Finalizar Compra';
      });
      var alvo = document.querySelector('.drawer__inner') || document.body;
      var aviso = document.getElementById('pa-checkout-aviso');
      if (!aviso) {
        aviso = document.createElement('p');
        aviso.id = 'pa-checkout-aviso';
        aviso.style.cssText = 'margin:.8rem 1.5rem 0;font-size:1.2rem;font-weight:700;color:#B4453A;text-align:center';
        alvo.appendChild(aviso);
      }
      aviso.textContent = 'Não consegui abrir o pagamento agora. Toque em Finalizar Compra de novo.';
      // o checkout não vingou e a pessoa continua na loja: libera a trava e deixa a regra
      // do brinde voltar ao normal, senão o carrinho fica sem brinde até recarregar
      indoPraCheckout = false;
      schedule();
    };

    var go = function () {
      var tentativas = 0;
      (function tentar() {
        if (typeof window.yampiClick === 'function') {
          window.yampiClick();
          // A Yampi ainda faz /cart.json + POST na API dela antes de redirecionar, e não
          // avisa quando isso falha. Se em 15s a página não saiu, devolve o botão em vez
          // de deixar a pessoa olhando uma bolinha eterna. Se navegou, o timer morre junto.
          setTimeout(paBotaoFalhou, 15000);
          return;
        }
        if (++tentativas > 40) { paBotaoFalhou(); return; }   // ~10s sem Yampi: avisa, NÃO manda pro checkout nativo
        setTimeout(tentar, 250);
      })();
    };
    // Spinner já no primeiro clique, sempre — antes era só quando a Yampi demorava, e no
    // caminho normal o botão ficava inerte por 1 a 3s (o loader da Yampi não aparece nesta
    // loja). Fica aqui, e não dentro do go(), para cobrir também a remoção do brinde abaixo.
    paBotaoCarregando();
    if (!vs.length || !strip) { go(); return; }

    // 1) Dá pra nem pedir nada quando não há brinde. O drawer marca a linha do brinde
    //    com .cart-item--gift, e o reconcile só libera `busy` DEPOIS de re-renderizar o
    //    drawer (chain.then(refreshDrawer) roda antes do finally que zera o busy). Logo,
    //    com busy falso o DOM está em dia com o carrinho de verdade — se não há linha de
    //    brinde, não há o que remover. Com busy true o reconcile está no meio do caminho
    //    e o DOM pode estar velho, então aí a gente pede por segurança.
    //    Vale para a maioria: a meta é R$280 e ~70% dos carrinhos ficam abaixo dela.
    var temBrinde = !!document.querySelector('cart-drawer .cart-item--gift');
    if (!busy && !temBrinde) { go(); return; }

    indoPraCheckout = true; // segura o reconcile pra não readicionar o brinde durante o checkout
    // 2) Um pedido em vez de dois. /cart/update.js aceita o ID DA VARIANTE como chave,
    //    então zera o brinde direto. Antes: GET /cart.js só pra achar a `key` da linha,
    //    depois POST /cart/change.js com ela (~970ms). Agora: ~690ms. O id continua vindo
    //    da mesma setting de sempre (pa_gift_variant_id), nada fixo aqui.
    // um pedido só mesmo com dois brindes: /cart/update.js aceita várias variantes
    var zerar = {};
    vs.forEach(function (id) { zerar[id] = 0; });
    postJSON('/cart/update.js', { updates: zerar }).then(go, go);
  };

  // Upsell: troca a foto ao mudar a variante
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.classList || !sel.classList.contains('pa-upsell__select') || sel.tagName !== 'SELECT') return;
    var opt = sel.options[sel.selectedIndex];
    var img = opt && opt.getAttribute('data-img');
    if (!img) return;
    var item = sel.closest('[data-pa-item]');
    var el = item && item.querySelector('img');
    if (el) el.src = img;
  });

  // Carrossel de upsell: setas + dots
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('.pa-uc__nav');
    if (!nav) return;
    var track = nav.closest('.pa-uc').querySelector('.pa-uc__track');
    var w = track.clientWidth;
    track.scrollBy({ left: nav.classList.contains('pa-uc__prev') ? -w : w, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track.classList || !track.classList.contains('pa-uc__track')) return;
    var i = Math.round(track.scrollLeft / track.clientWidth);
    var dots = track.closest('.pa-uc').querySelectorAll('.pa-uc__dot');
    dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();

/* ---------------------------------------------------------------------------
   Oferta de kit no carrinho (card "Leve mais 1"): clique do botão Adicionar.

   Este listener morava dentro de snippets/pa-cart-promo.liquid. Não podia:
   o snippet só é renderizado com o carrinho CHEIO, e quando o tema re-renderiza
   o drawer ele usa innerHTML — e script inserido por innerHTML não executa.
   Resultado: quem chegava na PDP com o carrinho vazio (o caso normal), adicionava
   o primeiro par e clicava em "Adicionar mais 1" não via nada acontecer.

   Aqui em cart-extras.js o arquivo carrega em toda página, o listener é delegado
   no document e registra uma vez só, independente de quando o card aparece.
   --------------------------------------------------------------------------- */
(function(){
  if (window.__paPromoDelegado) return;
  window.__paPromoDelegado = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pa-promo-add]');
    if (!btn) return;
    var card = btn.closest('[data-pa-promo]'); if (!card) return;
    var erro = card.querySelector('[data-pa-promo-erro]');
    var falta = parseInt(btn.dataset.falta, 10) || 1;
    var itens = [];

    if (btn.dataset.unico) {
      itens.push({ id: parseInt(btn.dataset.unico, 10), quantity: falta });
    } else {
      var variantes = JSON.parse(card.querySelector('[data-pa-promo-json]').textContent);
      var porChave = {};
      for (var i = 0; i < variantes.length; i++) porChave[variantes[i].o] = variantes[i].i;
      var falhou = false;
      card.querySelectorAll('.pa-promo__row').forEach(function (r) {
        var chave = Array.prototype.map.call(r.querySelectorAll('select'), function (s) { return s.value; }).join('|');
        var id = porChave[chave];            // só existe aqui se a variante está disponível
        if (!id) { falhou = true; return; }
        itens.push({ id: id, quantity: 1 });
      });
      if (falhou || itens.length !== falta) {
        erro.textContent = 'Essa combinação está indisponível.';
        erro.hidden = false;
        return;
      }
    }

    erro.hidden = true;
    // mesmo retorno visual do botão da PDP: bolinha girando dentro do próprio botão
    btn.dataset.paTexto = btn.innerHTML;
    btn.innerHTML = '<span class="pa-promo__spin" role="status" aria-label="Adicionando"></span>';
    btn.disabled = true;
    var devolveBotao = function () {
      btn.disabled = false;
      if (btn.dataset.paTexto) { btn.innerHTML = btn.dataset.paTexto; delete btn.dataset.paTexto; }
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itens, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (res) {
        var cd = document.querySelector('cart-drawer');
        var inner = cd && cd.querySelector('.drawer__inner');
        if (inner && res.sections && res.sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
          var ni = doc.querySelector('.drawer__inner');
          if (ni) { inner.innerHTML = ni.innerHTML; return; }
        }
        location.reload();
      })
      .catch(function () {
        devolveBotao();
        erro.textContent = 'Não consegui adicionar agora. Tente de novo.';
        erro.hidden = false;
      });
  }, false);
})();
